import ArchiverUtils from "../SUPPORT/ArchiverUtils";

/**
 * helper to get the image data from the image setter card
 */
export class ImageInfoStruct {
    encodedBytes;
    
    constructor(dataBytes = null, hasUnsavedData = false, newId = null) {
        this.dataBytes = dataBytes;
        this.EncodeDataBytes(dataBytes);
        this.hasUnsavedData = hasUnsavedData;
        this.newId = newId;
    }
    
    /**
     * return the image data as a base64 string
     */
    EncodeDataBytes(dataBytes) {
        let encodedBytes;
        if(dataBytes instanceof ArrayBuffer) {
            encodedBytes = ArchiverUtils.Base64EncodeArrayBuffer(dataBytes);
        }
        else { // convert to base64 string
            encodedBytes = btoa(dataBytes);
        }
        this.encodedBytes = encodedBytes;
    }
    
    SetupBasedOnEncodedBytes(encodedBytes) {
        this.encodedBytes = encodedBytes;
        if (!encodedBytes) {
            this.dataBytes = null;
            return;
        }
        this.dataBytes = atob(encodedBytes);
    }
}